/* mobileCasez — recently viewed (localStorage only). Premium feature: gated by
   the build integrity flag, degrades on unauthorized copies. */
(function () {
  'use strict';
  if (window.__mczOK === false) return;
  var KEY = 'mcz-recent';
  var MAX = 12;
  var sec = document.querySelector('[data-mcz-recent]');
  if (!sec) return;

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  // record current product
  var curEl = document.querySelector('[data-mcz-recent-cur]');
  var cur = null;
  if (curEl) {
    try { cur = JSON.parse(curEl.textContent); } catch (e) {}
    if (cur && cur.h) {
      var list = load().filter(function (x) { return x.h !== cur.h; });
      list.unshift(cur);
      save(list);
    }
  }

  var items = load().filter(function (x) { return !cur || x.h !== cur.h; });
  if (!items.length) return;

  var rail = sec.querySelector('[data-mcz-recent-rail]');
  rail.innerHTML = items.map(function (p) {
    return '<article style="position:relative;flex:0 0 clamp(200px,22vw,250px);scroll-snap-align:start;background:#FFFFFF;border:1px solid rgba(20,21,26,.1);border-radius:22px;padding:12px;box-shadow:0 1px 2px rgba(16,17,20,.04),0 14px 30px rgba(16,17,20,.06);transition:transform .3s ease" style-hover="transform:translateY(-6px)">' +
      '<a href="' + esc(p.u) + '" aria-label="' + esc(p.t) + '" style="position:absolute;inset:0;z-index:1;border-radius:22px"></a>' +
      '<div style="background:#FFFFFF;border-radius:14px;aspect-ratio:1/1;display:grid;place-items:center;overflow:hidden">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="360" height="360" style="width:82%;height:82%;object-fit:contain">' : '') +
      '</div>' +
      '<div style="padding:12px 6px 6px"><h3 style="font-size:14px;font-weight:600;margin:0;line-height:1.35">' + esc(p.t) + '</h3>' +
      (p.p ? '<div style="font-family:\'Unbounded\',sans-serif;font-weight:700;font-size:15px;margin-top:8px">' + p.p + '</div>' : '') +
      '</div></article>';
  }).join('');

  sec.hidden = false;
  if (window.__mczInit) window.__mczInit(sec);

  var clr = sec.querySelector('[data-mcz-recent-clear]');
  if (clr) clr.addEventListener('click', function () { try { localStorage.removeItem(KEY); } catch (e) {} sec.hidden = true; });
})();
